import React from 'react';

import { Search } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const navigation = [
    { name: 'Search', href: '/?focus=search', icon: Search },
    // { name: 'Pricing', href: '/pricing' },
    // { name: 'About', href: '/about' },
    // { name: 'Profile', href: '/profile' },
  ];

  const legal = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
    { name: 'Refund Policy', href: '/refund-policy' },
  ];

  return (
    <footer className="border-latte-cream bg-warm-sand/40 text-warm-espresso border-t shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Контейнер адаптивний */}
        <div className="flex flex-col justify-between gap-8 p-8 text-center md:flex-row md:gap-0 md:p-12 md:text-left">
          {/* Logo + опис */}
          <div className="flex-shrink-0 md:w-1/4">
            <Link to="/" aria-label="ScoreNest home" className="group flex items-center gap-3">
              {/* SHORT ICON LOGO */}
              <img
                src="/images/logo/Logo-alone.png"
                alt=""
                className="h-15 w-15 object-contain transition-transform duration-300 group-hover:scale-105"
              />

              {/* TEXT LOGO */}
              <img
                src="/images/logo/Logo-coffe-text.png"
                alt=""
                className="h-5 object-contain transition-opacity duration-300 group-hover:opacity-90"
              />
            </Link>
            <p className="mx-auto max-w-[250px] text-[15px] font-semibold md:mx-0 md:text-base">Built from public records and other data sources.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h6 className="text-warm-espresso mb-3 font-semibold">Quick Links</h6>
            <div className="flex flex-col gap-2">
              {navigation.map(item => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="!text-warm-espresso hover:!text-latte-caramel flex items-center justify-center text-[15px] font-semibold md:justify-start md:text-base"
                >
                  <span>{item.name}</span>
                </Link>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <h6 className="text-warm-espresso mb-3 font-semibold">Legal</h6>
            <div className="flex flex-col gap-2">
              {legal.map(item => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="!text-warm-espresso hover:!text-latte-caramel flex items-center justify-center text-[15px] font-semibold md:justify-start md:text-base"
                >
                  <span>{item.name}</span>
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h6 className="text-warm-espresso mb-3 font-semibold">Contact Us</h6>
            <div className="flex flex-col gap-2 text-[15px] font-semibold md:text-base">
              <p>ScoreNest LLC</p>
              <p>4301 Orchard Lake Rd,</p>
              <p>Suite 180</p>
              <p>West Bloomfield, MI 48323</p>
              <br />
              <p>contact@scorenest.com</p>
              <p>+1248-921-0569</p>
            </div>
          </div>
        </div>

        <div className="border-b-warm-espresso border-t py-6 text-center text-[15px] font-semibold md:text-base">
          <p>© {currentYear} ScoreNest. All rights reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
